import React, { ErrorInfo, PropsWithChildren } from "react";

export class GlobalErrorBoundary extends React.Component<PropsWithChildren, { hasError: boolean, message: string }> {
    constructor(props: PropsWithChildren) {
        super(props);
        this.state = { hasError: false, message: "" };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true }
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.log(JSON.stringify(error));
        console.log(JSON.stringify(info));
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="px-8 py-16">
                    <div className="flex flex-col max-w-4xl mx-auto">
                        <p>An unknown error occurred.</p>
                        <p>To report this error, please report the issue via Discord: <a target="_blank" href="https://discord.gg/mAErry4jUf">https://discord.gg/mAErry4jUf</a></p>
                        <pre className="bg-secondary p-4 rounded mt-4 max-h-300px">
                            <code>
                                {
                                    this.state.message
                                }
                            </code>
                        </pre>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}